<template>
  <v-icon v-if="display" :icon="display.icon" :color="display.color" />
  <v-progress-circular v-else indeterminate size="14" />
</template>

<script setup lang="ts">
import { SERVICE_STATUSES } from '@deepcloud/service-status'
import type { ServiceStatus } from '@deepcloud/service-status'

const props = defineProps<{
  status: ServiceStatus | undefined
}>()

const DISPLAY_BY_STATUS = {
  [SERVICE_STATUSES.UP]: { icon: 'fas fa-check-circle', color: 'success' },
  [SERVICE_STATUSES.DOWN]: {
    icon: 'fas fa-exclamation-circle',
    color: 'warning',
  },
  [SERVICE_STATUSES.UNREACHABLE]: { icon: 'fas fa-wifi-slash', color: 'grey' },
} as const satisfies Record<ServiceStatus, { icon: string; color: string }>

const display = computed(() =>
  props.status ? DISPLAY_BY_STATUS[props.status] : undefined,
)
</script>
